export default "__VITE_ASSET__BSHX6ReK__"